import React from 'react'
import Hook from './page'
import { userActions } from '../../redux/actions/user_actions'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import i18next from 'i18next'
import { compose } from 'redux'
import { alertActions } from '../../redux/actions/alert_actions'
import { withSnackbar } from 'notistack'

class Register extends React.Component {
    changeLanguage = lng => {
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng)
        })
    }

    render() {
        return <Hook {...this.props} changeLanguage={this.changeLanguage} />
    }
}

function mapState(state) {
    const { authenticationReducer, alertReducer } = state
    return { authenticationReducer, alertReducer }
}

const actionCreators = {
    register: userActions.register,
    clear: alertActions.clear,
}

export default compose(
    withTranslation('common'),
    withSnackbar,
    connect(mapState, actionCreators),
)(Register)
